import { supabase } from '../supabase';

export interface DbNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  recipient_id: string;
  vacancy_id: string | null;
  client_id: string | null;
  is_read: boolean;
  metadata: Record<string, any>;
  created_at: string;
  read_at: string | null;
}

export async function sendNotificationWebhook(notification: DbNotification): Promise<void> {
  try {
    const { data, error } = await supabase.functions.invoke('send-notification-webhook', {
      body: notification
    });

    if (error) {
      console.error('Error sending notification webhook:', error);
    } else {
      console.log('Notification webhook sent successfully:', data);
    }
  } catch (error) {
    console.error('Failed to send notification webhook:', error);
  }
}

export async function getNotifications(recipientId: string): Promise<DbNotification[]> {
  const { data, error } = await supabase
    .from('internal_notifications')
    .select('*')
    .eq('recipient_id', recipientId)
    .order('created_at', { ascending: false })
    .limit(50);

  if (error) {
    console.error('Error fetching notifications:', error);
    return [];
  }

  return data || [];
}

export async function getUnreadNotifications(recipientId: string): Promise<DbNotification[]> {
  const { data, error } = await supabase
    .from('internal_notifications')
    .select('*')
    .eq('recipient_id', recipientId)
    .eq('is_read', false)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching unread notifications:', error);
    return [];
  }

  return data || [];
}

export async function getUnreadCount(recipientId: string): Promise<number> {
  const { count, error } = await supabase
    .from('internal_notifications')
    .select('*', { count: 'exact', head: true })
    .eq('recipient_id', recipientId)
    .eq('is_read', false);

  if (error) {
    console.error('Error fetching unread count:', error);
    return 0;
  }

  return count || 0;
}

export async function markNotificationAsRead(notificationId: string): Promise<boolean> {
  const { error } = await supabase
    .from('internal_notifications')
    .update({
      is_read: true,
      read_at: new Date().toISOString()
    })
    .eq('id', notificationId);

  if (error) {
    console.error('Error marking notification as read:', error);
    return false;
  }

  return true;
}

export async function markAllNotificationsAsRead(recipientId: string): Promise<boolean> {
  const { error } = await supabase
    .from('internal_notifications')
    .update({
      is_read: true,
      read_at: new Date().toISOString()
    })
    .eq('recipient_id', recipientId)
    .eq('is_read', false);

  if (error) {
    console.error('Error marking all notifications as read:', error);
    return false;
  }

  return true;
}
